import _slicedToArray from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from "react"; // Hook, credits: https://usehooks.com/useWindowSize/

function getScreenSize() {
  if (!isClient) {
    return "large";
  } else {
    if (window.innerWidth < 600) {
      return "small";
    } else if (window.innerWidth < 900) {
      return "medium";
    } else {
      return "large";
    }
  }
}

var isClient = typeof window === "object";
export function useScreenSize() {
  var _useState = useState(getScreenSize()),
      _useState2 = _slicedToArray(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  useEffect(function () {
    if (!isClient) {
      return;
    }

    function handleResize() {
      setSize(getScreenSize());
    }

    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return size;
}